import { render, staticRenderFns } from "./GlobalFeatures.vue?vue&type=template&id=008412a5&scoped=true"
import script from "./GlobalFeatures.vue?vue&type=script&lang=js"
export * from "./GlobalFeatures.vue?vue&type=script&lang=js"
import style0 from "./GlobalFeatures.vue?vue&type=style&index=0&id=008412a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008412a5",
  null
  
)

export default component.exports